class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.handleVariantStates();
    this.handleColorSwatches();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    // this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.handleVariantStates();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      if( this.closest('.product')) {
        this.updateURL();
      }
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const condition = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`).length && !this.classList.contains('js-card-variants');
    const productForms = condition ? document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`) : [this.closest('.card__quick-add').querySelector('form')]

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');

      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    this.currentVariant.options.map((option, index) => {
      if (this.querySelector(`[data-product-option-value="option${index + 1}"]`)) {
        this.querySelector(`[data-product-option-value="option${index + 1}"]`).innerHTML = option
      }
    })
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const parentEl = document.getElementById(`product-form-${this.dataset.section}`) || this.closest('product-form')
    const addButton = parentEl?.querySelector('[name="add"]');
    const bisButton = parentEl?.closest('product-form')?.querySelector('.js-btn-back-in-stock')

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      addButton.classList.remove('hidden')
      bisButton?.classList.add('hidden')

      if (text) addButton.textContent = text;

      if (bisButton && text) {
        addButton.classList.add('hidden')
        bisButton.classList.remove('hidden')
        bisButton.click()
      }
    } else {
      addButton.removeAttribute('disabled');
      if (this.currentVariant.inventory_quantity <= 2 && !this.currentVariant.name.includes('Gift Card') ) {
        addButton.textContent = `${window.variantStrings.addToCart} - Only ${this.currentVariant.inventory_quantity} Left`;
      } else {
        addButton.textContent = window.variantStrings.addToCart;
      }
      
      if (bisButton) {
        addButton.classList.remove('hidden')
        bisButton.classList.add('hidden')
      }
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  handleColorSwatches() {
    const colorSwatchesInput = this.querySelector('.product-form__input--color .product-form__input--swatches');
    if (!colorSwatchesInput) return;

    const swatchMainColor = document.getElementById('swatchMainColor');
    const swatchGeneratedColor = document.getElementById('swatchGeneratedColor');
    const labels = colorSwatchesInput.querySelectorAll('.js-product-form__color-swatch');

    let mouseTimeIn  = 0;
    let mouseTimeOut = 0;
    let lastTargetValue = '';

    const currentColor = swatchMainColor.innerText;;

    labels.forEach((item, idx) => {
      item.addEventListener('mouseenter', (event) => {
          const targetValue = event.currentTarget.dataset.value;

          swatchGeneratedColor.innerHTML = targetValue;

          swatchGeneratedColor.classList.remove('show-from-bottom');
          swatchGeneratedColor.classList.add('fix');

          if ( swatchGeneratedColor.classList.contains( 'hide-from-center' ) ) {
            swatchMainColor.innerHTML = lastTargetValue;
            swatchGeneratedColor.style.top = '0';
          }
          else {
            swatchMainColor.innerHTML = currentColor;
          }

          swatchMainColor.classList.remove('show-from-bottom');
          swatchMainColor.classList.add('hide-from-center');

          swatchGeneratedColor.classList.remove('hide-from-center');
          swatchGeneratedColor.classList.add('show-from-bottom');

          setTimeout(() => {
            swatchGeneratedColor.classList.remove('fix');
          }, 1);

          if ( mouseTimeIn ) {
            window.clearTimeout( mouseTimeIn )
          }
          mouseTimeIn = setTimeout(() => {
            swatchMainColor.classList.remove('hide-from-center');
         }, 300 );

         lastTargetValue = targetValue;
      });

      item.addEventListener('mouseout', (event) => {
        event.preventDefault();
        swatchMainColor.innerHTML = currentColor;

        swatchMainColor.classList.remove('hide-from-center');
        swatchMainColor.classList.add('show-from-bottom');


        swatchGeneratedColor.classList.remove('show-from-bottom');
        swatchGeneratedColor.classList.add('hide-from-center');

        if ( mouseTimeOut ) {
          window.clearTimeout( mouseTimeOut )
        }
        mouseTimeOut = setTimeout(() => {
          swatchMainColor.classList.remove('hide-from-center');
          swatchGeneratedColor.classList.remove('hide-from-center');
       }, 300 );
      })
    });
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    if (this.getAttribute('data-select-type') == 'select-only') {
      this.options = Array.from(
        this.querySelectorAll('select'),
        (select) => select.getAttribute('data-value') || select.value
      )
    } else {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        const radio =  Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
        if (radio === undefined) {
          return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio)?.value
        } else {
          return radio
        }
      });
    }
  }

  handleVariantStates() {
    const inputs = this.querySelectorAll('fieldset input');
    const currentColor = this.currentVariant?.['option2'] || this.querySelector('[name="Color"]:checked')?.value

    if(!currentColor) return

    const filteredVariants = this.getVariantData().filter(
      (variant) => variant['option2'] === currentColor
    )

    inputs.forEach((input)=> {
      const variantData = filteredVariants.find(item => item['option1'] === input.value)
      const productCardInputWrapper = input.closest('.product-form__input-wrap')

      if(!variantData) return

      if(variantData?.available) {
        input.classList.remove('disabled');
        if (productCardInputWrapper) {
          productCardInputWrapper?.classList.remove('disabled')
        }
      } else {
        input.classList.add('disabled');
        if (productCardInputWrapper) {
          productCardInputWrapper?.classList.add('disabled')
        }
      }
    })
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductGroupSwatches extends HTMLElement {
  constructor() {
    super();
    const _self = this
    this.swatchChanging = false
    this.previousSwatch = []
    this.group = this.dataset.group
    this.productHandle = this.dataset.productHandle
    this.items = null
    this.fetchItems()
    document.addEventListener('click', this.handleGroupSwatchClick.bind(this))

    // Run once 
    if (document.body.classList.contains('popstate-listener-activate')) return
    window.addEventListener('popstate', function (event) {
      event.preventDefault()
      event.stopImmediatePropagation();
      setTimeout(() => {
        _self.handleGroupSwatchClick(null, window.location)
      }, 500);
      
    });
    document.body.classList.add('popstate-listener-activate')
  }

  async fetchItems () {
    this.items = await fetch(`/collections/all/${this.group}?view=ajax`).then(res => res.json())
    const optionsHtml = this.items.map(item => {
      return `<a
        href="${item.url}"
        style="background-image: url('${item.swatch_url}');"
        data-product="${item.handle}"
        data-value="${item.swatch_value}"
        class="product-form__color-swatch js-product-form__color-swatch ${this.productHandle === item.handle ? 'active' : ''} ${item.swatch_value === 'White' ? 'product-form__color-swatch--outline' : ''}"
        title="${item.swatch_value}"
      ><span class="visibility-hidden">${item.swatch_value}</span></a>`
    }).join('')

    this.innerHTML = optionsHtml;
    this.handleColorSwatches()
  }

  handleColorSwatches () {
    const swatchMainColor = document.getElementById('swatchMainColor');
    const swatchGeneratedColor = document.getElementById('swatchGeneratedColor');
    const labels = this.querySelectorAll('.js-product-form__color-swatch');

    let mouseTimeIn  = 0;
    let mouseTimeOut = 0;
    let lastTargetValue = '';

    const currentColor = swatchMainColor.innerText;;

    labels.forEach((item, idx) => {
      item.addEventListener('mouseenter', (event) => {
          const targetValue = event.currentTarget.dataset.value;

          swatchGeneratedColor.innerHTML = targetValue;

          swatchGeneratedColor.classList.remove('show-from-bottom');
          swatchGeneratedColor.classList.add('fix');

          if ( swatchGeneratedColor.classList.contains( 'hide-from-center' ) ) {
            swatchMainColor.innerHTML = lastTargetValue;
            swatchGeneratedColor.style.top = '0';
          }
          else {
            swatchMainColor.innerHTML = currentColor;
          }

          swatchMainColor.classList.remove('show-from-bottom');
          swatchMainColor.classList.add('hide-from-center');

          swatchGeneratedColor.classList.remove('hide-from-center');
          swatchGeneratedColor.classList.add('show-from-bottom');

          setTimeout(() => {
            swatchGeneratedColor.classList.remove('fix');
          }, 1);

          if ( mouseTimeIn ) {
            window.clearTimeout( mouseTimeIn )
          }
          mouseTimeIn = setTimeout(() => {
            swatchMainColor.classList.remove('hide-from-center');
         }, 300 );

         lastTargetValue = targetValue;
      });

      item.addEventListener('mouseout', (event) => {
        event.preventDefault();
        swatchMainColor.innerHTML = currentColor;

        swatchMainColor.classList.remove('hide-from-center');
        swatchMainColor.classList.add('show-from-bottom');


        swatchGeneratedColor.classList.remove('show-from-bottom');
        swatchGeneratedColor.classList.add('hide-from-center');

        if ( mouseTimeOut ) {
          window.clearTimeout( mouseTimeOut )
        }
        mouseTimeOut = setTimeout(() => {
          swatchMainColor.classList.remove('hide-from-center');
          swatchGeneratedColor.classList.remove('hide-from-center');
       }, 300 );
      })
    });
  }

  executeScriptElements(containerElement) {
    const scriptElements = containerElement.querySelectorAll("script");
  
    Array.from(scriptElements).forEach((scriptElement) => {
      const clonedElement = document.createElement("script");
  
      Array.from(scriptElement.attributes).forEach((attribute) => {
        clonedElement.setAttribute(attribute.name, attribute.value);
      });
      
      clonedElement.text = scriptElement.text;
  
      scriptElement.parentNode.replaceChild(clonedElement, scriptElement);
    });
  }

  async handleGroupSwatchClick (e, link = null) {
    const swatch = e?.target.closest('.js-product-form__color-swatch') || link
    if (!swatch) return;

    if ( e !== null ) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }

    document.body.setAttribute('inert', true);

    const href = swatch.href;
    const data = await fetch(href).then(res => res.text());
    const html = new DOMParser().parseFromString(data, 'text/html');

    document.body.classList.remove('animated-in');
    document.title = html.title;

    html.querySelector('#MainContent').id = 'MainContentLoading'
    document.querySelector('#MainContent').parentNode.insertBefore(html.querySelector('#MainContentLoading'), document.querySelector('#MainContent').nextSibling)

    if ( e !== null ) {
      window.history.pushState({}, html.title, href);
    }
    
    document.getElementById('swatchMainColor').style.visibility = 'hidden'
    setTimeout(() => {
      document.getElementById('swatchMainColor').style.visibility = 'visible'
    }, 200 );

    setTimeout(() => {
      document.body.classList.remove('animated-in');

      if (window.innerWidth > 1023) {
        const productInfoRect = document.querySelector('#MainContent .product__info-inner').getBoundingClientRect();
        document.querySelector('#MainContentLoading .product__info-inner').style.height = `${productInfoRect.height}px`;
      }

      const optionsNewHtml = this.items.map(item => {
        return `<a
          href="${item.url}"
          style="background-image: url('${item.swatch_url}');"
          data-product="${item.handle}"
          data-value="${item.swatch_value}"
          class="product-form__color-swatch js-product-form__color-swatch ${this.productHandle === item.handle ? 'active' : ''} ${item.swatch_value === 'White' ? 'product-form__color-swatch--outline' : ''}"
          title="${item.swatch_value}"
        ><span class="visibility-hidden">${item.swatch_value}</span></a>`
      }).join('');

      document.querySelector('#MainContentLoading product-group-swatches').innerHTML = optionsNewHtml;

      document.querySelector('#MainContent').remove()
      Array.from(document.querySelectorAll('.animated:not(.animated-in)')).map(el => {
        el.classList.add('animated-in')
      })
      document.body.removeAttribute('inert')
      document.querySelector('#MainContentLoading').id = 'MainContent'

      const productWishlistBtn = document.querySelector('.product-wishlist__container');
      this.executeScriptElements(productWishlistBtn);

      window.scrollTo(0,0);
    }, 100);
    
    setTimeout(() => {
      document.querySelector('input[checked="checked"][name="Size"]').checked = true;
    }, 300);
  }
}

customElements.define('product-group-swatches', ProductGroupSwatches);
